"use client";

import React, { useRef } from "react";

import Button from "./Button";
import FA_LANG from "@/assets/locale/fa";
import Image from "next/image";
import icons from "@/assets/icons";

type ImageUploaderProps = {
  handler?: (image: any) => void;
  imageUrl?: string;
  error?: boolean;
  errorMessage?: string;
  editable: boolean;
  width: string;
  height: string;
  uniqueId?: string;
  onImageClick?: (
    event: React.MouseEvent<HTMLImageElement>,
    imageRef: React.MutableRefObject<HTMLImageElement>
  ) => void;
  definedPoints?: Point[];
  removePoints?: Function;
};
const ImageUploader = ({
  handler,
  imageUrl,
  error,
  errorMessage,
  editable,
  width,
  height,
  uniqueId,
  onImageClick,
  definedPoints,
  removePoints,
}: ImageUploaderProps) => {
  const imageRef = useRef<HTMLImageElement | null>(null);

  function onImageChange(e: any) {
    if (handler) handler(e.target?.files?.[0]);
  }

  function resetImage() {
    if (handler) handler(undefined);
  }
  return (
    <div className="w-full h-full">
      <div
        className={`inline-flex flex-col items-center rounded-2xl border-2 ${
          imageUrl ? "border-none" : "border-dashed"
        } border-bg-cards2 bg-gray-0  pt-20 relative ${width} ${height}`}
      >
        {!imageUrl ? (
          <div className="inline-flex flex-col items-center self-center image-upload">
            <label
              htmlFor={uniqueId}
              className="inline-flex flex-col items-center gap-3 text-text-caption2 text-[10px] "
            >
              <div className="w-16 h-16">{icons.upload}</div>
              {FA_LANG.SELECT_FILE}
            </label>
            <input id={uniqueId} type="file" onChange={onImageChange} />
          </div>
        ) : (
          editable && (
            <div>
              <div className="absolute bottom-2 left-2 flex flex-row gap-2.5 z-10">
                <label
                  htmlFor={uniqueId}
                  className="w-[24px] h-[22px] p-1 rounded-full bg-gray-0 justify-center items-center hover:bg-tertiary"
                >
                  <div className="w-4 h-4"> {icons.edit}</div>
                </label>
                <input id={uniqueId} type="file" onChange={onImageChange} />
                <Button
                  styleClass="w-[22px] h-[22px] p-1  rounded-full bg-gray-0 hover:bg-tertiary"
                  icon={icons.trash}
                  fullWidth={true}
                  handleClick={resetImage}
                  iconHeight="h-4"
                  iconWidth="w-4"
                />
              </div>
            </div>
          )
        )}
        {imageUrl !== undefined && (
          <Image
            key={imageUrl?.length}
            src={imageUrl}
            alt=""
            width={600}
            height={560}
            ref={imageRef}
            className={`absolute top-0 overflow-hidden rounded-xl ${width} ${height}`}
            onClick={(event: React.MouseEvent<HTMLImageElement>) =>
              onImageClick ? onImageClick(event, imageRef) : () => {}
            }
            onError={(e) => console.error(e.target)}
          />
        )}
        {definedPoints &&
          definedPoints.map((point, index) => (
            <div
              onClick={() => removePoints(index)}
              key={index}
              style={{
                position: "absolute",
                top: point.y,
                left: point.x,
                width: 50,
                height: 50,
                backgroundColor: "transparent",
                border: "3px solid ",
                borderColor: "green",
                borderRadius: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          ))}
      </div>
      {error && (
        <div className="text-error-text text-right text-[10px] font-medium leading-4">
          {error ? errorMessage : ""}
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
